import {
  Flex,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  Select,
  Input,
  Radio,
  RadioGroup,
  Text,
  HStack,
} from '@chakra-ui/react';

import DateField from 'components/fields/DateField';
import { SectionCard, ValidatedField } from '../../components';
import { useAnswerCodes } from '../../hooks/useAnswerCodes';
import {
  VEHICLE_TYPES,
  SUPPORTED_PROVINCES_NUMERIC,
  type AutoPolicyBasicInfoProps,
} from './types';

const AutoPolicyBasicInfo = ({
  province,
  vehicleType,
  effectiveDate,
  businessNameVehicles,
  businessName,
  onFieldChange,
  isUpdating,
}: AutoPolicyBasicInfoProps) => {
  const { isEffectiveDateValid } = useAnswerCodes();
  const isEffectiveDateInvalid = !isEffectiveDateValid;

  return (
    <SectionCard mb={4}>
      <Grid
        templateColumns={{ base: '1fr', md: 'repeat(6, 1fr)' }}
        gap={4}
        mb={4}
      >
        <GridItem colSpan={{ base: 6, md: 1 }}>
          <FormControl>
            <FormLabel fontSize="sm" fontWeight="600">
              Province
            </FormLabel>
            <Select
              value={province}
              onChange={(e) =>
                onFieldChange('province', parseInt(e.target.value))
              }
              variant="main"
              size="sm"
            >
              {SUPPORTED_PROVINCES_NUMERIC.map((p) => (
                <option key={p.value} value={p.value}>
                  {p.label}
                </option>
              ))}
            </Select>
          </FormControl>
        </GridItem>

        <GridItem colSpan={{ base: 6, md: 2 }}>
          <ValidatedField
            itemPath="policy"
            fieldPath="vehicle_type"
            label="Vehicle Type"
            entity={{ vehicle_type: vehicleType }}
          >
            <Select
              value={vehicleType}
              onChange={(e) => onFieldChange('vehicle_type', e.target.value)}
              variant="main"
              size="sm"
              placeholder="Select type"
            >
              {VEHICLE_TYPES.map((t) => (
                <option key={t.value} value={t.value}>
                  {t.label}
                </option>
              ))}
            </Select>
          </ValidatedField>
        </GridItem>

        <GridItem colSpan={{ base: 6, md: 3 }}>
          <DateField
            label="Effective Date"
            date={effectiveDate ? new Date(effectiveDate + 'T00:00:00') : null}
            required
            isInvalid={isEffectiveDateInvalid}
            onChange={(date: Date | null) => {
              if (date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                onFieldChange('effective_date', `${year}-${month}-${day}`);
              } else {
                onFieldChange('effective_date', '');
              }
            }}
          />
        </GridItem>
      </Grid>

      <Flex align="center">
        <Text fontSize="sm" fontWeight="600" mr={4}>
          Are any of the vehicles in a business name?
        </Text>
        <RadioGroup
          value={businessNameVehicles ? 'yes' : 'no'}
          onChange={(v) => onFieldChange('business_name_vehicles', v === 'yes')}
        >
          <HStack spacing={4}>
            <Radio value="yes" colorScheme="blue">
              Yes
            </Radio>
            <Radio value="no" colorScheme="blue">
              No
            </Radio>
          </HStack>
        </RadioGroup>
      </Flex>
      {businessNameVehicles && (
        <Input
          mt={3}
          placeholder="Enter business name"
          value={businessName}
          onChange={(e) => onFieldChange('business_name', e.target.value)}
          variant="main"
          size="sm"
        />
      )}
    </SectionCard>
  );
};

export default AutoPolicyBasicInfo;
